import gsap, { Power1 } from "gsap";

import { GetBy } from "../_app/cuchillo/core/Element";
import { Metrics } from '../_app/cuchillo/core/Metrics';
import { isDebug } from '../_app/cuchillo/core/Basics';
import Header from './Header';

export default class Preloader {
    _container;
    _linesV;
    _linesH;
    _logo;
    _wrapper;
    _headerFake;

    static init() {
        this._container = GetBy.id('Preloader');
        this._headerFake = GetBy.id('HeaderFake');
        this._logo = GetBy.class('logo', this._headerFake)[0];
        this._logoSubtitle = GetBy.selector('svg', this._logo)[1];
        this._wrapper = GetBy.class("wrapper", this._container)[0];
        this._linesH = [...GetBy.selector(".lines-h .line", this._container)];
        this._linesV = [...GetBy.selector(".lines-v .line", this._container)];

        gsap.set(this._wrapper, { top: '-80%', rotate: '-2deg', left: '-100%' });
        gsap.set(this._linesH, { "--progress": 0 });
        gsap.set(this._linesV, { "--progress": 0 });

        gsap.set(this._logo, {
            x: '100vw',
            y: '25vh',
            rotate: '-90deg',
        });
    }

    static update(__progress) { }

    static hide(__call) {
        // if (isDebug) {
        //     this._container.style.display = "none";
        //     if (__call) __call();
        //     return;
        // }

        gsap.to(this._wrapper, {
            top: '30%',
            duration: 3,
            ease: "power2.Out"
        });
        gsap.to(this._wrapper, {
            left: 0,
            rotate: '-6deg',
            duration: 4,
            ease: "power2.Out"
        });
        gsap.to(this._wrapper, {
            top: '140%',
            duration: 2.5,
            delay: 3,
            ease: "power2.inOut"
        });
        gsap.to(this._wrapper, {
            rotate: '-12deg',
            duration: 1.5,
            delay: 4,
            ease: "power2.inOut"
        });

        gsap.to(this._container, {
            "--gap-line": '2rem',
            duration: 4,
            delay: 2,
            ease: "power4.inOut"
        });

        gsap.to(this._logo, {
            x: '25vw',
            duration: 2,
            delay: 3.75,
            ease: 'power2.out'
        });
        gsap.to(this._logo, {
            y: '15vh',
            duration: 2,
            delay: 4.25,
            ease: 'power2.out'
        });
        gsap.to(this._logo, {
            rotate: 0,
            duration: 4.5,
            delay: 3.5,
            ease: 'power2.out'
        });
        gsap.to(this._logoSubtitle, {
            opacity: 0,
            duration: .5,
            delay: 5.25,
            ease: 'power2.out'
        });
        gsap.to(this._logo, {
            x: 0,
            duration: 1.5,
            delay: 5.75,
            ease: 'power2.inOut'
        });
        gsap.to(this._logo, {
            y: 0,
            duration: 1,
            delay: 6.25,
            ease: 'power2.inOut',
            onComplete: () => {
                Header.show(() => {
                    this._headerFake.style.display = "none";
                });
            }
        });

        let delay = 0;
        this._linesH.forEach((line, i) => {
            delay += 0.15;
            gsap.to(line, {
                "--progress": 1,
                duration: 1.5 - i * 0.05,
                ease: "power3.inOut",
                delay
            });
        });

        delay += 0.25;
        this._linesV.forEach((line, i) => {
            gsap.to(line, {
                "--progress": 1,
                duration: 1.5,
                ease: "power4.inOut",
                delay
            });
            delay += 0.15;
        });


        delay += 1;
        gsap.to(this._container, {
            duration: .3,
            opacity: 0,
            delay,
            onComplete: () => {
                this._container.style.display = "none";
                if (__call) __call();
            }
        });
    }

    static directHide(__call) {
        if (isDebug) {
            this._headerFake.style.display = "none";
            this._container.style.display = "none";
            if (__call) __call();
            return;
        }

        gsap.to(this._container, {
            duration: .3,
            opacity: 0,
            delay: 0,
            onComplete: () => {
                this._container.style.display = "none";
                this._headerFake.style.display = "none";
                if (__call) __call();
            }
        });
    }
}
